import React, {lazy, Suspense} from "react";
import {Modal} from "react-bootstrap";
import './BookACallModal.css';

const CalendlyWidget = lazy(() =>
    import("react-calendly").then((module) => ({default: module.InlineWidget}))
);

export const BookCallModal = ({show, handleClose}) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Body>
                <Suspense fallback={<div style={{minHeight: 400}}>Loading...</div>}>
                    {show && (
                        <CalendlyWidget url="https://calendly.com/ucarsolutions/dmarc-flow"/>
                    )}
                </Suspense>
            </Modal.Body>
        </Modal>
    );
};
